<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="1200px"
    height="900px"
    style="background-color: #fff"
    @keydown.esc="chiudi()"
  >
    <v-card style="height: 900px !important; background-color: #fff">
      <v-toolbar-title>
        <v-btn icon @click="chiudi()"> <v-icon>close</v-icon> </v-btn>
      </v-toolbar-title>
      <!-- <iframe
        id="iframe"
        v-if="pathPdf"
        :src="pathPdf"
        width="100%"
        height="790px"
      >
        Caricamento....
      </iframe> -->
      <figure style="height: 790px !important">
        <embed
          id="iframe"
          :src="pathPdf"
          class="embedSet"
          type="application/pdf"
          width="100%"
          height="790px"
        />
      </figure>

      <v-card-actions style="background-color: #fff">
        <v-spacer></v-spacer>
        <v-btn @click.prevent="chiudi()">Annulla</v-btn>
        <v-btn @click.prevent="conferma()">Conferma</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { get_schedaAnagrafica } from "@/api/api.agenti.js";

export default {
  props: { dialog: { type: Boolean, default: false } },

  data: () => ({
    pathPdf: "",
  }),

  methods: {
    async getSchedaAnagrafica() {
      let res = await get_schedaAnagrafica();
      this.pathPdf = res.data;
      if (this.pathPdf == null || this.pathPdf == "") this.chiudi();
    },

    async chiudi() {
      /* let confirm = await this.$root.$confirm(
        "Chiudi",
        "Vuoi chiudere il documento? Tutte le modifiche saranno cancellate."
      );
      if (!confirm) return; */

      this.$emit("chiudiDialog");
    },

    /* chiudiDialog() {
      this.$emit("chiudiDialog");
    }, */

    conferma() {
      let iframe = document.getElementById("iframe");
      if (iframe.contentDocument) {
        console.log(iframe.contentDocument);
      }
      console.log(iframe.getSVGDocument());
    },
  },

  watch: {
    dialog() {
      if (this.dialog) this.getSchedaAnagrafica();
    },
  },

  computed: {},
};
</script>